import { FileText } from "lucide-react";
import type { LineageNode } from "../types";
import { NodeShell } from "./NodeShell";

interface Props {
  data: LineageNode;
  selected?: boolean;
}

export function CampaignBriefNode({ data, selected }: Props) {
  return <NodeShell node={data} icon={FileText} selected={selected} />;
}
